import i from "./ghl-ui.es1669.js";
function u(r, e, t) {
  return e = i(e), e in r ? Object.defineProperty(r, e, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : r[e] = t, r;
}
export {
  u as default
};
